import { combineReducers } from 'redux';
import autoRefresh from "./auto-refresh";
import onboarding from "./onboarding";
import transactions from "./transactions";
import investmentHoldings from "./investment-holdings";
import searchResults from "./search-results";
import providers from "./providers";
import topTakeaways from "./top-takeaways";
import migratedAccountsMap from "./migrated-accounts-map";
export default combineReducers({
  autoRefresh: autoRefresh,
  investmentHoldings: investmentHoldings,
  migratedAccountsMap: migratedAccountsMap,
  onboarding: onboarding,
  providers: providers,
  searchResults: searchResults,
  topTakeaways: topTakeaways,
  transactions: transactions
});